export default __webpack_public_path__ + "static/media/complementary--except-vehicles--g1.89da1dbd.png";